import React from 'react';
import { cn } from '../../utils/cn';
import { useTerminology } from '../../hooks/useTerminology';
interface PanelProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}
export function Panel({
  title,
  description,
  action,
  children,
  className,
  bodyClassName
}: PanelProps) {
  // Panel headings name concepts constantly ("Properties", "Roommate matches"),
  // so they resolve terminology templates. Plain text passes through unchanged.
  const {
    phrase
  } = useTerminology();
  return <section className={cn('rounded-card border border-line bg-surface shadow-panel', className)} data-id="element-5926" data-mp="1wv66py8lzgrb">
      {(title || action) && <header className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 border-b border-line px-5 py-4" data-id="element-5927" data-mp="21reg0v04kfqk">
          <div className="min-w-0" data-id="element-5928" data-mp="1sst3bghc3uxp">
            {title && <h2 className="text-h4 font-semibold text-ink" data-id="element-5929" data-mp="1ssja7k0zt7ns">{phrase(title)}</h2>}
            {description && <p className="mt-1 text-body-sm text-ink-muted" data-id="element-5930" data-mp="2hbimqdoyzo7w">{phrase(description)}</p>}
          </div>
          {action}
        </header>}
      <div className={cn('px-5 py-4 sm:px-6 sm:py-5', bodyClassName)} data-id="element-5931" data-mp="2rbrl9y6fplqg">{children}</div>
    </section>;
}